import { PayloadAction, createSlice } from '@reduxjs/toolkit';
export interface SnackbarOptions {
  variant: 'success' | 'error' | 'warning' | 'info';
}
export interface GlobalState {
  opened: boolean;
  folded: boolean;
  mobileOpened: boolean;
  dialog: string;
  snackbarOpen: boolean;
  snackbarMessage: string;
  snackbarOptions: SnackbarOptions;
}

const initialState: GlobalState = {
  opened: false,
  folded: true,
  mobileOpened: false,
  dialog: '',
  snackbarOpen: false,
  snackbarMessage: '',
  snackbarOptions: {
    variant: 'info',
  },
};

interface ShowSnackbarPayload {
  message: string;
  options?: Partial<SnackbarOptions>;
}

const globalSlice = createSlice({
  name: 'global',
  initialState,
  reducers: {
    toggleNarvarAction: (state) => {
      state.opened = !state.opened;
    },
    openNarvarAction: (state) => {
      state.opened = true;
    },
    closeNarvarAction: (state) => {
      state.opened = false;
    },
    foldNarvarAction: (state) => {
      state.folded = true;
    },
    unfoldNarvarAction: (state) => {
      state.folded = false;
    },
    toggleMobileNarvarAction: (state) => {
      state.mobileOpened = !state.mobileOpened;
    },
    openMobileNarvarAction: (state) => {
      state.mobileOpened = true;
    },
    closeMobileNarvarAction: (state) => {
      state.mobileOpened = false;
    },
    openDialogAction: (state, action: PayloadAction<string>) => {
      state.dialog = action.payload;
    },
    closeDialogAction: (state) => {
      state.dialog = '';
    },
    
    showSnackbarAction(state, action: PayloadAction<ShowSnackbarPayload>) {
      state.snackbarOpen = true;
      state.snackbarMessage = action.payload.message;
      state.snackbarOptions = {
        variant: 'info',
        ...action.payload.options,
      };
    },
    hideSnackbarAction(state) {
      state.snackbarOpen = false;
    },

    globalClearAction: (state) => {
      return initialState;
    },
  },
});

export const {
  toggleNarvarAction,
  openNarvarAction,
  closeNarvarAction,
  foldNarvarAction,
  unfoldNarvarAction,
  toggleMobileNarvarAction,
  openMobileNarvarAction,
  closeMobileNarvarAction,
  openDialogAction,
  closeDialogAction,
  showSnackbarAction,
  hideSnackbarAction,

  globalClearAction,
} = globalSlice.actions;

export default globalSlice.reducer;